import { useEffect } from 'react';
import { appConfig } from '../config/appConfig';

/**
 * Naslov kartice preglednika + theme-color iz konfiguracije firme.
 */
export default function DocumentHead() {
  useEffect(() => {
    document.title = appConfig.appTitle;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', appConfig.metaDescription);
    const theme = document.querySelector('meta[name="theme-color"]');
    if (theme) theme.setAttribute('content', appConfig.themeColor);
  }, []);

  return null;
}
